import React from "react";
import loadable from "@loadable/component";

function Loading() {
    return <div />;
}
export default loadable(() => import(/* webpackChunkName: 'sticky' */ "../Sticky"), {
    fallback: <Loading />,
});
